var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.966 10.55H5.914c-.05.05-.1.1-.1.15v5c0 .05 0 .1-.05.15-.05.05-.1.05-.151.05H1.554c-.1 0-.2-.1-.2-.2v-5c0-.1-.101-.2-.201-.2H.15c-.2 0-.251-.25-.1-.35L3.457 8h.2l3.408 2.2.05.05c.05.1.05.2-.05.25-.05 0-.05.05-.1.05ZM20.246 0H17.39c-.552 0-1.053.25-1.404.7l-.3.35c-.351.45-.852.7-1.403.7h-8.97c-.953-.05-1.755.75-1.755 1.7V7.3c.15 0 .351.05.501.15l3.408 2.2c.351.2.501.6.351 1-.1.4-.451.65-.852.65h-.451v4.5c0 .1 0 .2-.05.25h13.781c.952 0 1.754-.8 1.754-1.75V1.75C22 .8 21.198 0 20.246 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f396aa61897268d284a16932a4f1448a.svg";
export { ForwardRef as ReactComponent };